import { Button } from "@planningcenter/tapestry-react"
import Attendee from "./Attendee"
import FooterDetails from "./FooterDetails"
import { array, bool, func, object, shape, string } from "prop-types"

const AttendeeSection = ({
  attendee,
  event,
  onAttendeeCancel,
  onAttendeeRestore,
  isActingStaff = false,
  isAdmin = false,
  allowCancel = true,
  allowRestore = true
}) => {
  return (
    <>
      <Attendee event={event} attendee={attendee} isActingStaff={isActingStaff} isAdmin={isAdmin} />

      <div className="d-f@sm ai-c jc-sb mt-1@print mb-2@print">
        <FooterDetails
          createdAt={attendee.createdAt}
          createdBy={attendee.createdBy}
          isCanceled={attendee.isCanceled}
          canceledOn={attendee.canceledOn}
        />

        {!attendee.isCanceled && allowCancel && (
          <Button
            title="Cancel attendee"
            size="sm"
            variant="outline"
            onClick={() =>
              onAttendeeCancel({
                path: attendee.paths.cancel,
                alertText:
                  attendee.assignments.length > 0
                    ? "This attendees assignments will also be deleted"
                    : null
              })
            }
          />
        )}
        {attendee.isCanceled && allowRestore && (
          <Button
            title="Restore attendee"
            size="sm"
            variant="outline"
            onClick={() =>
              onAttendeeRestore({
                path: attendee.paths.cancel,
                alertText: attendee.restoreAlertText
              })
            }
          />
        )}
      </div>
    </>
  )
}

AttendeeSection.propTypes = {
  attendee: shape({
    createdAt: string,
    createdBy: object,
    isCanceled: bool,
    canceledOn: string,
    paths: shape({
      cancel: string
    }),
    assignments: array,
    restoreAlertText: string
  }).isRequired,
  event: object.isRequired,
  onAttendeeCancel: func.isRequired,
  onAttendeeRestore: func.isRequired,
  isActingStaff: bool,
  isAdmin: bool,
  allowCancel: bool,
  allowRestore: bool
}

export default AttendeeSection
